import { createAsyncThunk } from "@reduxjs/toolkit";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export const signup = createAsyncThunk(
  "user/signup",
  async (data, thunkAPI) => {
    const { name, email, password, role } = data;
    const response = await fetch(`${API_URL}/auth/signup`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        name: name,
        email: email,
        password: password,
        role: role,
      }),
    });
    const result = await response.json();
    if (!response.ok) {
      return thunkAPI.rejectWithValue(result);
    }

    return result;
  },
);

export const login = createAsyncThunk("user/login", async (data, thunkAPI) => {
  const { email, password } = data;
  const response = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      email: email,
      password: password,
    }),
  });
  const result = await response.json();
  if (!response.ok) {
    return thunkAPI.rejectWithValue(result);
  }

  return result;
});

export const authenticate = createAsyncThunk(
  "user/authenticate",
  async (_, thunkAPI) => {
    const response = await fetch(`${API_URL}/auth/check`, {
      method: "GET",
      credentials: "include",
    });
    const result = await response.json();
    if (!response.ok) {
      return thunkAPI.rejectWithValue(result);
    }

    return result;
  },
);

export const logoutThunk = createAsyncThunk(
  "user/logout",
  async (_, thunkAPI) => {
    const response = await fetch(`${API_URL}/auth/logout`, {
      method: "POST",
      credentials: "include",
    });
    const result = await response.json();
    if (!response.ok) {
      return thunkAPI.rejectWithValue(result);
    }
    return result;
  },
);
